module.exports = __webpack_public_path__ + "img/rona_4kl.5a80a9c3.jpg";